import Icon from '../../components/Icon.vue'

Icon.register({"regular/folder-open":{"width":576,"height":512,"paths":[{"d":"M527.9 224H480V176C480 149.5 458.5 128 432 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H448A48-48 0 0 1 488.7 425.4L568.6 297.4C588.6 265.5 565.6 224 527.9 224zM54 112H188.1L252.1 176H426A6-6 0 0 0 432 182V224H152A48-48 0 0 1 110.9 247.2L48 351.4V118A6-6 0 0 0 54 112zM448 400H72L149.2 272H528L448 400z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/folder-open.js
// module id = null
// module chunks = 